import React, { useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { toast } from 'react-toastify'

import { deleteMetricSessionStorage } from '../../../features/metric/metricSlice'
import { appendModel } from '../../../features/site/siteSlice'
import { updateUser } from '../../utils/Users'
import { updateSite } from '../../utils/Organizations'
import { appendOnboarding } from '../../../features/session/sessionSlice'
import history from '../../../history'

function OnboardingFooter(){
    const nextBtnRef = useRef(null)

    const dispatch = useDispatch()

    const [onboardingLoading, setOnboardingLoading] = useState(false)

    const model = useSelector(state => state.site.model)
    const onboardingState = useSelector(state => state.session.onboarding)
    const isAdmin = useSelector(state => state.session.isAdmin)
    const user = useSelector(state => state.session.user)

    const nextStep = async() => {
        const site = model?.sites[model?.siteActiveIdx]

        let sites = [...model?.sites]
        let all = [...model?.all]

        if(onboardingState.step === 1){
            // Retrieve GA here
            await updateSite(site.siteId, null, {
                site:{...model.siteForm}
            })
            
            sites[model?.siteActiveIdx] = {...model.siteForm}

            const allIdx = all.findIndex(a => a.siteId === model.siteForm.siteId)
            if(allIdx){
                all[allIdx] = {...model.siteForm}
            }
            
            await dispatch(appendModel({
                sites,
                all
            }))

            toast.success("Google Analytics are being collected!", {containerId: "defaultToastContainer"})
        } else if(onboardingState.step === 4){
            await updateUser(null, {...user,  enableIntroTutorial: true})
            await updateSite(site.siteId, null, {
                site:{
                    ...model.siteForm,
                    attr: {
                        ...model.siteForm.attr,
                        status: "onboarded"
                    }
                }
            })
            
            sites[model?.siteActiveIdx] = {
                ...model.siteForm,
                attr: {
                    ...model.siteForm.attr,
                    status: "onboarded"
                }
            }

            const sForm = {
                ...model.siteForm,
                attr: {
                    ...model.siteForm.attr,
                    status: "onboarded"
                }
            }

            const allIdx = all.findIndex(a => a.siteId === model.siteForm.siteId)
            if(allIdx){
                all[allIdx] = {...model.siteForm}
            }
            
            await dispatch(appendModel({
                sites,
                all,
                siteForm: {...sForm}
            }))

            await dispatch(deleteMetricSessionStorage())

            localStorage.removeItem("gaSelection")
            localStorage.removeItem("ga4Selection")
            localStorage.removeItem("gmbSelection")
            localStorage.removeItem("fbSelection")
            localStorage.removeItem("fbPageSelection")
            localStorage.removeItem("bingSelection")
            localStorage.removeItem("linkedinSelection")
            localStorage.removeItem("linkedinOrgSelection")
            localStorage.removeItem("oauthTokens")

        } else if(onboardingState.step === 5){

            if(site?.attr?.expediteOnboarding){
                await updateUser(null, {...user,  enableIntroTutorial: true})
                await updateSite(site.siteId, null, {
                    site:{
                        ...model.siteForm,
                        attr: {
                            ...model.siteForm.attr,
                            status: "onboarded"
                        }
                    }
                })
                
                sites[model?.siteActiveIdx] = {
                    ...model.siteForm,
                    attr: {
                        ...model.siteForm.attr,
                        status: "onboarded"
                    }
                }

                const sForm = {
                    ...model.siteForm,
                    attr: {
                        ...model.siteForm.attr,
                        status: "onboarded"
                    }
                }

                const allIdx = all.findIndex(a => a.siteId === model.siteForm.siteId)
                if(allIdx){
                    all[allIdx] = {...model.siteForm}
                }
                
                await dispatch(appendModel({
                    sites,
                    all,
                    siteForm: {...sForm}
                }))

                await dispatch(deleteMetricSessionStorage())

                localStorage.removeItem("gaSelection")
                localStorage.removeItem("ga4Selection")
                localStorage.removeItem("gmbSelection")
                localStorage.removeItem("fbSelection")
                localStorage.removeItem("fbPageSelection")
                localStorage.removeItem("bingSelection")
                localStorage.removeItem("linkedinSelection")
                localStorage.removeItem("linkedinOrgSelection")
                localStorage.removeItem("oauthTokens")
            } else {
                sites[model?.siteActiveIdx] = {...model.siteForm}

                const allIdx = all.findIndex(a => a.siteId === model.siteForm.siteId)
                if(allIdx){
                    all[allIdx] = {...model.siteForm}
                }
                
                await dispatch(appendModel({
                    sites,
                    all
                }))
                await updateSite(model.siteForm?.siteId, null, {
                    site:{
                        ...model.siteForm
                    }
                })
                await dispatch(deleteMetricSessionStorage())
            }
        } else if(onboardingState.step === 6){
            if(site?.attr?.expediteOnboarding){
                await updateSite(site.siteId, null, {
                    site:{
                        ...model.siteForm
                    },
                    questions: Object.values(onboardingState.qAndA)
                })
            }
        }

        let currentStep = onboardingState.step + 1

        if(site?.attr?.expediteOnboarding){
            currentStep = onboardingState.step === 1 ? 3 : onboardingState.step === 4 ? 8 : onboardingState.step + 1
        }

        await dispatch(appendOnboarding({
            step: currentStep
        }))

        nextBtnRef.current?.blur()
    }

    const previousStep = async() => {
        let currentStep = onboardingState.step - 1

        await dispatch(appendOnboarding({
            step: currentStep
        }))
    }

    const goToOnboarding = () => {
        setOnboardingLoading(true)

        setTimeout(async() => {

            await dispatch(appendOnboarding({
                step: 1
            }))

            history.push("/onboarding")
        }, 3000)
    }

    const site = model?.sites?.length > 0 && model.siteActiveIdx !== -1 ? model.sites[model.siteActiveIdx] : {}

    let nextEnabled = false
    let prevEnabled = false
    let nextText = "Next"

    switch(onboardingState.step){
        case 1:
            nextEnabled = (model?.siteForm?.attr?.accounts?.ga?.tokenId.includes("ga4:") && 
                model?.siteForm?.attr?.accounts?.ga?.propertyId)
            prevEnabled = false
        break;
        case 2:
            nextEnabled = (onboardingState.dontHaveIt.fbPage || model.siteForm?.attr?.accounts?.fbPage) &&
                (onboardingState.dontHaveIt.gmb || model.siteForm?.attr?.accounts?.gmb) &&
                (onboardingState.dontHaveIt.linkedinOrg || model.siteForm?.attr?.accounts?.linkedinOrg)
            prevEnabled = false
        break;
        case 3:
            nextEnabled = (onboardingState.dontHaveIt.fb || model.siteForm?.attr?.accounts?.fb) &&
                (onboardingState.dontHaveIt.bing || model.siteForm?.attr?.accounts?.bing) &&
                (onboardingState.dontHaveIt.linkedin || model.siteForm?.attr?.accounts?.linkedin)
            prevEnabled = true
        break;
        case 4:
            nextEnabled = true
            prevEnabled = true
            nextText = "Submit"
        break;
        case 5:
            nextEnabled = true
            prevEnabled = false
            nextText = site?.attr?.expediteOnboarding ? "Next" : "Finish"
        break;
        case 6:
            nextEnabled = Object.values(onboardingState.qAndA).reduce((prev, curr) => {
                if(curr.answer === ""){
                    prev = false
                }

                return prev
            }, true)

            nextText = site?.attr?.expediteOnboarding ? "Submit" : "Next"
        break;
        case 7:
            nextEnabled = onboardingState.videoEnded
            prevEnabled = false
        break;
        default:
        break;
    }

    if(nextEnabled && onboardingState.step <= 3){
        nextBtnRef.current?.focus()
    }

    return <div id="footer" style={{borderTop: "1px solid rgb(40, 70, 153)"}} class={`bg-white app-footer mb-0 ml-0 mr-0 mt-3 p-20 d-flex justify-content-end align-items-end ${onboardingState.step >= 1 ? "fixed-bottom": ""}`}>
        <div>
            {((site?.attr?.expediteOnboarding && onboardingState.step >= 1 && onboardingState.step <= 7) || 
                (!site?.attr?.expediteOnboarding && onboardingState.step >= 1 && onboardingState.step <= 5)) ? <div class="d-flex justify-content-end">
                {onboardingState.step > 1 && ((site?.attr?.expediteOnboarding && onboardingState.step < 7) ||
                    (!site?.attr?.expediteOnboarding && onboardingState.step < 5)) && <button className="btn btn-outline-primary btn-lg mr-3" disabled={!prevEnabled} onClick={() => previousStep()}>Previous</button>}
                <button ref={nextBtnRef} id="onboardingNextBtn" className={`btn btn-primary btn-lg ${nextEnabled && "pulse-blue"}`} disabled={!nextEnabled} onClick={() => nextStep()}>
                    {nextText}
                </button>
            </div> : <button className="btn btn-lg btn-dark" disabled={isAdmin || onboardingLoading} onClick={() => goToOnboarding()}>
                Connect Google Analytics {onboardingLoading && <div class="spinner-border text-light spinner-border-sm" role="status">
                    <span class="sr-only">Loading...</span>
                </div>}
            </button>}
        </div>
    </div>
}

export default OnboardingFooter